import { RequestDto, RequestForCreationDto } from '@oncolens/oncolens-ui/lib/dto/event/request';
import api from '@/utils/httpClient';

export const createRequest = (data: RequestForCreationDto) => {
  return api
    .post('/api/collaborationrequests', data)
    .then((response) => response.data as RequestDto);
};
